import { Box, GridItem, useDisclosure } from "@chakra-ui/react";
import { FC } from "react";
import { TeamUserListingItemGrid } from "./teamUserListingItemGrid";
import { ManageTeamInvitesModal } from ".";
import { IoIosAddCircleOutline } from '@react-icons/all-files/io/IoIosAddCircleOutline';
import { PermissionLevels } from "lib/types/user";
import { useComponentAccess } from "lib/hooks";

export const TeamUserListingInvite: FC = () => {
  const inviteModal = useDisclosure();
  const { hasAccess } = useComponentAccess([PermissionLevels.OWNER, PermissionLevels.ADMIN]);

  if (!hasAccess) {
    return null;
  }

  return (
    <Box
      w={"100%"}
      layerStyle={["with-hover", "with-clickable"]}
      borderRadius={"md"}
      pr={[3, 4]}
      pl={[3, 4]}
      pt={3}
      pb={3}
      bgColor={"bg.50"}
      border="1px dashed"
      borderColor="border.500"
      boxShadow="none"
      color="text.500"
      onClick={inviteModal.onOpen}
    >
      <TeamUserListingItemGrid>
        <GridItem colSpan={1}>
          <IoIosAddCircleOutline size="32px" />
        </GridItem>
        <GridItem rowSpan={2}>
          Invite team members
        </GridItem>
      </TeamUserListingItemGrid>
      <ManageTeamInvitesModal isOpen={inviteModal.isOpen} onClose={inviteModal.onClose} />
    </Box>
  )
}
